// WAW: cart PAGE only. The server decides whether the cart may check out (snippets/waw-cart-state.liquid) and renders
// that into the notice inside the footer's .js-contents, which Dawn replaces on every cart change. The checkout button
// and the dynamic checkout buttons sit outside that part, so they are re-toggled here. The cart drawer needs none of
// this: the server re-renders it whole.
(() => {
  const footer = document.getElementById('main-cart-footer');
  if (!footer) return;

  const apply = () => {
    const notice = footer.querySelector('[data-waw-cart-state]');
    if (!notice) return;
    const blocked = notice.dataset.wawCartState === 'blocked';
    footer.querySelector('#checkout')?.toggleAttribute('disabled', blocked || footer.classList.contains('is-empty'));
    footer.querySelector('[data-waw-dynamic-checkout]')?.toggleAttribute('hidden', blocked);
  };

  // childList only: apply() changes attributes, so it can never re-trigger itself.
  new MutationObserver(apply).observe(footer, { childList: true, subtree: true });
  apply();
})();
